export enum DipRegistrationBbfpUrls {
    TEST = 'https://bcdn-test.td.com/scripts/181e494/76eaedb1.js',
    PROD = 'https://bcdn.td.com/scripts/dfb31537/dfb31537.js'
}
